import AutocompleteInput from "global/Autocomplete/AutocompleteInput";
import InputText from "global/InputText/InputText";
import OTP from "global/otp";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

interface OrderHeaderProps {
  formik?: any;
}

const OrderHeader = ({ formik }: OrderHeaderProps) => {


  const senderRef = useRef(null);

  useEffect(() => {
    senderRef?.current?.focus();
  }, []);

  return (
    <div className="max-w-6xl px-6">
      <div className="flex-between-center  Max-md:flex-col gap-4 my-6 ">
        <InputText
          ref={senderRef}
          label="نام و نام خانوادگی"
          name="sender.name"
          handleChange={formik?.handleChange}
          values={"اعتبار سنجی نشانی اتباع"}
          important
          error={formik?.touched?.sender?.name && formik?.errors?.sender?.name}
          wrapperClassName="w-full"
          readOnly
        />
        <InputText
          dir="ltr"
          label="کد ملی"
          name="sender.nationalCode"
          handleChange={formik?.handleChange}
          values={"14005115779"}
          // important
          error={
            formik?.touched?.sender?.nationalCode &&
            formik?.errors?.sender?.nationalCode
          }
          wrapperClassName="w-full"
          maxLength={10}
          readOnly
        />
        <InputText
          dir="ltr"
          label="موبایل"
          name="sender.mobile"
          handleChange={formik?.handleChange}
          values={"09330000121"}
          important
          error={
            formik?.touched?.sender?.mobile && formik?.errors?.sender?.mobile
          }
          wrapperClassName="w-full"
          maxLength={13}
          readOnly
        />
      </div>
    </div>
  );
};

export default OrderHeader;
